import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    // backgroundColor: "#F6F7F9",
  },
  headerContainer: {
    paddingTop: theme.spacing(3),
  },
  content: {
    padding: theme.spacing(2),
  },
  formControl: {
    marginBottom: theme.spacing(2),
  },
  AvatarSmall: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#57769A",
  },
  AvatarText: {
    textAlign: "left",
    fontSize: 25,
  },
  accountTab: {
    marginBottom: theme.spacing(4),
  },
  updateButton: {
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    height: "40.5px",
    width: "100%",
  },
  roleSelection: {
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px",
  },
  dialogContent: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  startingTab: {
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    borderRight: "0",
  },
  endingTab: {
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    borderLeft: "0.02px solid #3F51B5",
  },
  tabRoot: {
    "& .MuiTabs-indicator": {
      background: "none",
    },
  },
  tabActive: {
    opacity: 1,
    backgroundColor: "rgba(63, 81, 181, 0.08)",
  },
  profileSection: {
    [theme.breakpoints.up("md")]: {
      marginLeft: theme.spacing(16),
    },
  }
}), { index: 999 });

export default useStyles;
